import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBottombarHiddenBottomWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBottombarHiddenBottomWide"><Path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM6 16H18V14H6V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBottombarHiddenBottomWide;
